export const CLEANUP_CANCEL_BOOKING_STATE = 'cleanup-cancel-booking-state';
const cleanupCancelBookingState = () => ({ type: CLEANUP_CANCEL_BOOKING_STATE });
export default cleanupCancelBookingState;
